import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ElementRef,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { RowActionId, RowActionItem } from '../../models/child-table-row-actions.models';
import { NAVIGATION_KEYS } from '../../models/child-table.models';

@Component({
  selector: 'child-table-row-menu',
  templateUrl: './child-table-row-menu.component.html',
  styleUrls: ['./child-table-row-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChildTableRowMenuComponent implements AfterViewInit {
  @ViewChild('menuEl') menuEl!: ElementRef<HTMLElement>;

  @Input() rowIndex = -1;
  @Input() items: RowActionItem[] = [];
  @Input() menuId = '';

  @Output() action = new EventEmitter<RowActionId>();
  @Output() close = new EventEmitter<void>();

  /** Expose the menu element for the parent's positioning service */
  get nativeElement(): HTMLElement | null {
    return this.menuEl?.nativeElement ?? null;
  }

  ngAfterViewInit(): void {
    this.focusFirstItem();
  }

  onKeydown(event: KeyboardEvent): void {
    event.stopPropagation();
    const menu = this.menuEl?.nativeElement;
    if (!menu) return;

    const btns = Array.from(
      menu.querySelectorAll('button.context-menu-item:not([disabled])')
    ) as HTMLElement[];
    if (btns.length === 0) return;

    const active = globalThis.document.activeElement as HTMLElement | null;
    const idx = active ? btns.indexOf(active) : -1;

    const focusAt = (i: number) => btns[Math.max(0, Math.min(btns.length - 1, i))]?.focus();

    switch (event.key) {
      case NAVIGATION_KEYS.ARROW_DOWN:
        event.preventDefault();
        focusAt(idx >= 0 ? (idx + 1) % btns.length : 0);
        return;
      case NAVIGATION_KEYS.ARROW_UP:
        event.preventDefault();
        focusAt(idx >= 0 ? (idx - 1 + btns.length) % btns.length : btns.length - 1);
        return;
      case NAVIGATION_KEYS.HOME:
        event.preventDefault();
        focusAt(0);
        return;
      case NAVIGATION_KEYS.END:
        event.preventDefault();
        focusAt(btns.length - 1);
        return;
      case NAVIGATION_KEYS.ESCAPE:
      case NAVIGATION_KEYS.TAB:
        event.preventDefault();
        this.close.emit();
        return;
    }
  }

  private focusFirstItem(): void {
    setTimeout(() => {
      const first = this.menuEl?.nativeElement?.querySelector(
        'button.context-menu-item:not([disabled])'
      ) as HTMLElement | null;
      first?.focus();
    }, 0);
  }
}
